import de from './de/countries.json';
import en from './en/countries.json';
import fr from './fr/countries.json';
import nl from './nl/countries.json';

const countries = { fr, en, nl, de };

export const deCountriesLocale = { countries: de as Record<string, string> };
export const enCountriesLocale = { countries: en as Record<string, string> };
export const frCountriesLocale = { countries: fr as Record<string, string> };
export const nlCountriesLocale = { countries: nl as Record<string, string> };

export default countries;
